const BASE_URL = import.meta.env.VITE_API_URL !== undefined && import.meta.env.VITE_API_URL !== ""
  ? import.meta.env.VITE_API_URL
  : (import.meta.env.DEV ? "http://localhost:8000" : "");

async function apiCall(endpoint, method = "GET", body = null) {
  const options = {
    method,
    headers: { "Content-Type": "application/json" },
  };
  if (body) options.body = JSON.stringify(body);

  try {
    const res = await fetch(`${BASE_URL}${endpoint}`, options);

    if (!res.ok) {
      const err = await res.json().catch(() => ({ detail: null }));
      if (res.status === 502 || res.status === 503 || res.status === 504) {
        throw new Error("Server wake up hone me 20-30 seconds lag rahe hain. Kripya thodi der me dobara try karein.");
      }
      throw new Error(err.detail || `HTTP ${res.status}`);
    }
    return res.json();
  } catch (err) {
    if (err.message.includes("Failed to fetch")) {
      throw new Error("Server se connect nahi ho pa raha. Server start ho raha hai, kripya 15 seconds baad try karein.");
    }
    throw err;
  }
}


export const chatAPI = {
  sendMessage: (message, sessionId) =>
    apiCall("/chat", "POST", { message, session_id: sessionId }),

  resetSession: (sessionId) =>
    apiCall("/reset", "POST", { session_id: sessionId }),
};

export const plannerAPI = {
  generateReport: (projectDetails) =>
    apiCall("/report", "POST", projectDetails),
};

export const estimateAPI = {
  estimate: (payload) =>
    apiCall("/estimate", "POST", payload),
};

export const boqAPI = {
  calculateBOQ: (payload) =>
    apiCall("/calculate/boq", "POST", payload),
};

export const vastuAPI = {
  auditVastu: (orientations) =>
    apiCall("/calculate/vastu-audit", "POST", { orientations }),
};

export const loanAPI = {
  calculateLoanSchedule: (payload) =>
    apiCall("/calculate/loan-schedule", "POST", payload),
};

export const ragAPI = {
  getStats: () => apiCall("/rag/stats"),
  getDocs: (category = null) =>
    apiCall(`/rag/docs${category ? `?category=${encodeURIComponent(category)}` : ""}`),
  search: (q, category = null) =>
    apiCall(`/rag/search?q=${encodeURIComponent(q)}${category ? `&category=${category}` : ""}`),
};

export const healthAPI = {
  check: () => apiCall("/health"),
};

export const floorPlanAPI = {
  generate: (payload) => apiCall("/calculate/floor-plan", "POST", payload),
};

export const contractAPI = {
  compare: (payload) => apiCall("/calculate/contract-comparison", "POST", payload),
};

export const brandPricesAPI = {
  getPrices: (city = "Nagpur") => apiCall(`/market/brand-prices?city=${encodeURIComponent(city)}`),
};

export const defectAPI = {
  audit: (payload) => apiCall("/audit/defect", "POST", payload),
};
